import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const LoginPage = Loadable(lazy(() => import('./components/LoginPage')));
const RegisterPage = Loadable(lazy(() => import('./components/RegisterPage')));
const ForgotPasswordPage = Loadable(lazy(() => import('./components/ForgotPasswordPage')));
const ResetPasswordPage = Loadable(lazy(() => import('./components/ResetPasswordPage')));
const CheckMailPage = Loadable(lazy(() => import('./components/CheckMailPage')));
const CodeVerificationPage = Loadable(lazy(() => import('./components/CodeVerificationPage')));
const EmailLinkCallbackPage = Loadable(lazy(() => import('./components/EmailLinkCallbackPage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/LoginRoutes.jsx today (it supplies the
 * GuestGuard + MinimalLayout shell), src/app/router.tsx once that exists (AGENTS.md §1).
 */
export const authRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/check-mail',
    element: <CheckMailPage />
  },
  {
    path: '/code-verification',
    element: <CodeVerificationPage />
  },
  {
    path: '/email-link-signin',
    element: <EmailLinkCallbackPage />
  }
];
